<div class="flex flex-wrap row-gap-3 align-items-center justify-content-between">
  <div class="flex gap-2 text-xl font-bold my-2 mr-5">
    @if (backNavigation) {
      <span>
        <i
          class="pi pi-arrow-left text-primary cursor-pointer"
          pTooltip="Voltar"
          tooltipPosition="bottom"
          (click)="backNavigate()"
          >
        </i>
      </span>
    }

    <span>
      {{ pageTitle ?? routeTitle }}
    </span>

    @if (showTooltip) {
      <span>
        <i
          class="pi pi-info-circle text-primary cursor-pointer"
          (click)="op.toggle($event)"
          [attr.data-tooltip]="tooltipKey"
        ></i>
      </span>
    }

    <span>
      <ng-content select="[extraHeaderIcons]"></ng-content>
    </span>

    @if (onCopyUrlFilters.observed) {
      <span>
        <i
          class="pi pi-link text-primary cursor-pointer"
          pTooltip="Copiar endereço com filtros para área de transferencia"
          tooltipPosition="bottom"
          (click)="onCopyUrlFilters.emit()"
        ></i>
      </span>
    }
  </div>

  <p-popover #op>
    <ng-template pTemplate="content">
      <div class="tooltip-overlay" [innerHTML]="tooltipHtml | safeHtml" [attr.data-content]="tooltipHtml"></div>
      @if (tooltipUrl && (suporteVisible$ | async)) {
        <div class="mt-4">
          <a class="text-primary" [href]="tooltipUrl" target="_blank" rel="noopener">
            Documentação
            <i class="pi pi-external-link text-sm ml-1"></i>
          </a>
        </div>
      }
      @if (podeEditarOrientacoes$ | async) {
        <div class="mt-2 text-sm">
          <a
            pTooltip="Editar este conteúdo"
            tooltipPosition="bottom"
            class="link"
            href="{{ orientacoesEditUrl }}"
            target="_blank"
            rel="noopener"
            >
            Editar
          </a>
        </div>
      }
    </ng-template>
  </p-popover>

  <div><ng-content select="[header]"></ng-content></div>
</div>

<div class="mt-3">
  <ng-content></ng-content>
</div>
